import { FetchTargetRate_fetchTargetRate } from "_graphql/queries/__generated__/FetchTargetRate";
import { FC } from "react";

interface TargetRateViewProps {
  rate: FetchTargetRate_fetchTargetRate | null;
}

const TargetRateView: FC<TargetRateViewProps> = ({ rate }) => {
  if (!rate) return <div>No rate data available</div>;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900">Rate Information</h3>
        <div className="mt-2 grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm font-medium text-gray-500">Rate Value</p>
            <p className="mt-1 text-sm text-gray-900">
              {rate.currency_code} {rate.rate_value}
            </p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Currency</p>
            <p className="mt-1 text-sm text-gray-900">
              {rate.currency || "N/A"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TargetRateView;
